/* eslint-disable import/no-anonymous-default-export */
import { REHYDRATE } from 'redux-persist'
import { AppActionType } from './../types'
import { Util } from './../../utils'

const defaultState = {
  successMessage: null,
  errorMessage: null,
  loading: false,
  currentAct: null,
  networkSpeed: 0,
  locale: String(navigator.language || navigator.userLanguage).substr(0, 2) ?? 'en',
  menuOpen: false,
  menuContent: null,
  videoOpen: false,
  vrVideo: null,
  currentSite: "factory",
  infoOpen: false,
  vrInfo: null,
  currentSong: null,
  muted: false,
  currentGama: null,
  currentCollection: null,
  currentStep: "gama",
  currentVisit: null,
  infoType: "info",
  currentMap: null
}

export default (state = defaultState, action) => {
  switch (action.type) {

    case REHYDRATE:
      action.payload !== undefined
        ? action.payload.app !== undefined ? document.title = Util.setTitle(action.payload.app.locale) : document.title = Util.setTitle(defaultState.locale)
        : document.title = Util.setTitle(defaultState.locale)
      return {
        ...state,
        locale:
          action.payload !== undefined
            ? action.payload.app !== undefined ? action.payload.app.locale : defaultState.locale
            : defaultState.locale,

        currentSite:
          action.payload !== undefined
            ? action.payload.app !== undefined ? action.payload.app.currentSite : defaultState.currentSite
            : defaultState.currentSite
      }

    case AppActionType.UPDATE_CURRENT_ACT:
      return {
        ...state,
        currentAct: action.payload
      }

    case AppActionType.UPDATE_NETWORK_SPEED:
      return {
        ...state,
        networkSpeed: action.payload
      }

    case AppActionType.SET_MENU:
      return {
        ...state,
        menuOpen: action.payload
      }

    case AppActionType.SET_MENU_CONTENT:
      return {
        ...state,
        menuContent: action.payload
      }

    case AppActionType.SET_VIDEO:
      return {
        ...state,
        videoOpen: action.payload.condition,
        vrVideo: action.payload.content
      }

    case AppActionType.UPDATE_LANGUAGE:
      document.title = Util.setTitle(action.payload)
      return { ...state, locale: action.payload }

    case AppActionType.SET_INFO:
      return {
        ...state,
        infoOpen: action.payload.condition,
        vrInfo: action.payload.content,
        infoType: action.payload.type
      }

    case AppActionType.UPDATE_CURRENT_SONG:
      return {
        ...state,
        currentSong: action.payload
      }

    case AppActionType.UPDATE_MUTED:
      return {
        ...state,
        muted: action.payload
      }

    case AppActionType.UPDATE_CURRENT_SITE:
      return {
        ...state,
        currentSite: action.payload
      }
    case AppActionType.SET_CURRENT_COLLECTION:
      return {
        ...state,
        currentCollection: action.payload
      }

    case AppActionType.SET_CURRENT_GAMA:
      return {
        ...state,
        currentGama: action.payload
      }

    case AppActionType.SET_CURRENT_STEP:
      return {
        ...state,
        currentStep: action.payload
      }

      case AppActionType.SET_CURRENT_MAP:
        return {
          ...state,
          currentMap: action.payload
        }

    default: return { ...state }
  }
}
